import { render, staticRenderFns } from "./DeductCommodityFromWarehouse.vue?vue&type=template&id=72d34e72&scoped=true&"
import script from "./DeductCommodityFromWarehouse.vue?vue&type=script&lang=js&"
export * from "./DeductCommodityFromWarehouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d34e72",
  null
  
)

export default component.exports